import type { LiveInterviewSessionSummary } from '@/services/interview-coach/types'

export function isLiveInterviewSignalActive(summary: LiveInterviewSessionSummary): boolean {
    if (summary.status !== 'active') return false
    // RTMS stream is the only live signal for Zoom-bound interviews.
    if (summary.zoomRtmsConnectedAt) return true
    // In-browser / sim conductor capture — not historical zoom surface after disconnect.
    if (summary.surface === 'sim' && summary.turnCount > 0) return true
    return false
}

export function liveInterviewSignalLabel(summary: LiveInterviewSessionSummary): string {
    if (summary.zoomMeetingBound) {
        if (summary.turnCount > 0) {
            return summary.turnCount === 1 ? '1 turn captured' : `${summary.turnCount} turns captured`
        }
        if (summary.zoomRtmsConnectedAt) return 'Live transcript connected'
        return 'Zoom meeting linked — waiting for transcript'
    }
    if (summary.turnCount > 0) {
        return summary.turnCount === 1 ? '1 turn captured' : `${summary.turnCount} turns captured`
    }
    return 'Interview in progress'
}

export function liveInterviewLivePath(sessionId: string): string {
    return `/dashboard/interviews/${sessionId}/live`
}
